/*
 * /ml-callback — o Mercado Livre devolve o ?code= aqui depois que o Mestre autoriza.
 * Esta página pega o code e entrega ao motor (bridge local) que troca por token.
 * Precisa rodar no PC onde o bridge está ligado (localhost:8787).
 */
import React, { useEffect, useState } from "react";
import { BRIDGE } from "config"; // fonte única (OKF)

function MLCallback() {
  const [msg, setMsg] = useState("Conectando sua conta do Mercado Livre...");
  const [ok, setOk] = useState(null);

  useEffect(() => {
    const code = new URLSearchParams(window.location.search).get("code");
    if (!code) { setOk(false); setMsg("Não veio o código do Mercado Livre. Tente autorizar de novo."); return; }
    fetch(BRIDGE + "/ml/exchange?code=" + encodeURIComponent(code))
      .then((r) => r.json())
      .then((d) => {
        if (d.ok) { setOk(true); setMsg("Conta conectada! Conta ML #" + d.user_id + ". Redirecionando..."); setTimeout(() => (window.location.href = "/admin/marketplace"), 1800); }
        else { setOk(false); setMsg("Não consegui trocar o código: " + (d.erro || JSON.stringify(d.detalhe || d))); }
      })
      .catch(() => { setOk(false); setMsg("Motor (bridge) desligado. Ligue o bridge no PC (node server.js) e tente de novo."); });
  }, []);

  const cor = ok === true ? "#00f2c3" : ok === false ? "#ff5c5c" : "#ffd700";
  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#1e1e2f", color: "#fff", fontFamily: "sans-serif" }}>
      <div style={{ textAlign: "center", maxWidth: 460, padding: 30 }}>
        <div style={{ width: 64, height: 64, borderRadius: 16, background: "#ffe600", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 18px" }}>
          <i className="fas fa-shopping-cart" style={{ fontSize: 30, color: "#2d3277" }} />
        </div>
        <h4 style={{ margin: "0 0 8px" }}>Conector Mercado Livre</h4>
        <p style={{ color: cor, fontSize: 15 }}>{msg}</p>
        {ok === false && (
          <a href="/admin/marketplace" style={{ color: "#ffd700" }}>Voltar ao painel</a>
        )}
      </div>
    </div>
  );
}

export default MLCallback;
